import { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Badge, Typography, Box, useTheme } from "@mui/material";
import { Bell, User } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { PageStyles } from "../../styles/pageStyles";
import { EventSourcePolyfill } from 'event-source-polyfill';
import { ApiConfig } from '@shared/Config/config';
// import { apiHandler } from '@shared/Functions/apiHandler';
// import { CommonServices } from "../../Services/CommonServices";

export default function Header() {

    const [count, setCount] = useState(0);
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const theme = useTheme();
    const classes = PageStyles(theme);

    const setEmailer = () => {
        let email = sessionStorage.getItem("email");
        setEmail(email || "");
    }

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        const source = new EventSourcePolyfill(
            `${ApiConfig.baseUrl}/admin/notificationCountStream`,
            {
                headers: {
                    Authorization: `${token}`,
                },
                withCredentials: true, // include cookies if needed
            }
        );
        source.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log(typeof (data?.data?.count), "typeof");
            console.log(data?.data?.count, "data");
            setCount(data?.data?.count);

        };
        source.onerror = (err) => {
            console.error('EventSource Error:', err);
        };
        return () => source.close();
    }, []);

    useEffect(() => {
        setEmailer();
    }, []);

    return (
        <>

            <Box sx={classes.flex_end}>

                <IconButton color="inherit" size="small"
                    onClick={() => { navigate("/home/notifications") }}
                    sx={{ width: 35, height: 35, mr:3 }}
                    >
                    <Badge badgeContent={count} color="error" >
                        <Bell size={20} />
                    </Badge>
                </IconButton>

                {/* Profile */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box sx={classes.userIcon}>
                        <User size={18} />
                    </Box>
                    <Box>
                        <Typography variant="body2" fontWeight="500">
                            Dispatcher
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {email}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );
}
